import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Department = {
	name: NAME,
	apiProvider,
	router,
};
